<template>
  <section>
    <div class="title is-5 has-text-centered">
      Consolidado
      <hr class="dropdown-divider" aria-role="menuitem" />
    </div>

    <b-table :data="data" striped hoverable>
      <b-table-column
          field="area"
          label="Área Académica"
          width="30%"
          v-slot="props"
      >
        {{ props.row.area }}
      </b-table-column>

      <b-table-column
          field="hours_committed_weekly"
          label="Horas/Semana Comprometidas"
          width="15%"
          v-slot="props"
      >
        {{ props.row.hours_committed_weekly }}
      </b-table-column>

      <b-table-column
          field="hours_committed_yearly"
          label="Horas/Año Comprometidas"
          width="15%"
          v-slot="props"
      >
        {{ props.row.hours_committed_yearly }}
      </b-table-column>



      <b-table-column
          field="hours_completed_weekly"
          label="Horas/Semana Realizadas"
          width="15%"
          v-slot="props"
      >
        {{ props.row.hours_completed_weekly }}
      </b-table-column>

      <b-table-column
          field="hours_completed_yearly"
          label="Horas/Año Realizadas"
          width="15%"
          v-slot="props"
      >
        {{ props.row.hours_completed_yearly }}
      </b-table-column>


      <b-table-column
          field="percentage"
          label="Porcentaje"
          width="10%"
          v-slot="props"
      >
        {{ props.row.percentage_completed + "%" }}
      </b-table-column>
    </b-table>

    <div>
      <table class="table is-fullwidth">
        <thead>
        <tr>
          <th style="width: 30%"></th>
          <th style="width: 15%">Semanales</th>
          <th style="width: 15%">Anuales</th>
          <th style="width: 15%">Semanales</th>
          <th style="width: 15%">Anuales</th>
          <th style="width: 10%"></th>
        </tr>
        </thead>
        <tbody>
        <tr>
          <td style="width: 30%">Horas Cronológicas Promedio Anual</td>
          <td style="width: 15%">{{ hours_weekly }}</td>
          <td style="width: 15%">{{ hours_yearly }}</td>
          <td style="width: 15%">{{ hours_completed_weekly }}</td>
          <td style="width: 15%">{{ hours_completed_yearly }}</td>
          <td style="width: 10%"></td>
        </tr>

        <tr>
          <td style="width: 30%">Horas Semanales Equivalentes Totales</td>
          <td style="width: 15%">{{ hours_eq }}</td>
          <td style="width: 15%"></td>
          <td style="width: 15%">{{ hours_completed_eq }}</td>
          <td style="width: 10%"></td>
        </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
export default {
  name: "AcademicConsolidated",

  props: ["academic_areas", "performances"],

  data() {
    return {
      data: [],
      hours_weekly: 0.0,
      hours_yearly: 0.0,
      hours_eq: 0.0,
      hours_completed_weekly: 0.0,
      hours_completed_yearly: 0.0,
      hours_completed_eq: 0.0,
    };
  },

  created() {
    this.getConsolidated();
    this.calculateConsolidated();
  },

  methods: {
    getConsolidated() {
      this.data = this.academic_areas.map((area) => {
        return {
          academic_area_id: area.id,
          area: area.alt_name,
          hours_committed_weekly: 0.0,
          hours_committed_yearly: 0.0,
          hours_completed_weekly: 0.0,
          hours_completed_yearly: 0.0,
          hours_committed_weekly_1: 0.0,
          hours_committed_yearly_1: 0.0,
          hours_committed_weekly_2: 0.0,
          hours_committed_yearly_2: 0.0,
          hours_completed_weekly_1: 0.0,
          hours_completed_yearly_1: 0.0,
          hours_completed_weekly_2: 0.0,
          hours_completed_yearly_2: 0.0,
          percentage: 0.0,
          percentage_completed: 0.0,
        };
      });
    },

    calculateConsolidated() {
      this.data.forEach((area) => {
        area.hours_committed_weekly = 0.0;
        area.hours_committed_yearly = 0.0;
        area.hours_completed_weekly = 0.0;
        area.hours_completed_yearly = 0.0;
        area.hours_committed_weekly_1 = 0.0;
        area.hours_committed_yearly_1 = 0.0;
        area.hours_committed_weekly_2 = 0.0;
        area.hours_committed_yearly_2 = 0.0;
        area.hours_completed_weekly_1 = 0.0;
        area.hours_completed_yearly_1 = 0.0;
        area.hours_completed_weekly_2 = 0.0;
        area.hours_completed_yearly_2 = 0.0;
      });

      this.performances.forEach((performance) => {
        let area = this.data.find(
            (area) => area.academic_area_id === performance.academic_area_id
        );
        let area_index = this.data.findIndex(
            (area) => area.academic_area_id === performance.academic_area_id
        );
        if (area) {
          if (performance.is_weekly_hours) {
            area.hours_committed_weekly_1 += parseFloat(
                performance.hours_committed_semester_1
            );
            area.hours_committed_weekly_2 += parseFloat(
                performance.hours_committed_semester_2
            );

            area.hours_completed_weekly_1 += parseFloat(
                performance.hours_completed_semester_1
            );
            area.hours_completed_weekly_2 += parseFloat(
                performance.hours_completed_semester_2
            );
          } else {
            area.hours_committed_yearly_1 += parseFloat(
                performance.hours_committed_semester_1
            );
            area.hours_committed_yearly_2 += parseFloat(
                performance.hours_committed_semester_2
            );

            area.hours_completed_yearly_1 += parseFloat(
                performance.hours_completed_semester_1
            );
            area.hours_completed_yearly_2 += parseFloat(
                performance.hours_completed_semester_2
            );

          }
          this.data[area_index] = area;
        }
      });

      let total = 0.0;
      let total_completed = 0.0;

      this.data.forEach((area) => {
        area.hours_committed_weekly = parseFloat(
            (
                (area.hours_committed_weekly_1 + area.hours_committed_weekly_2) /
                2
            ).toFixed(1)
        );
        area.hours_committed_yearly = parseFloat(
            (
                area.hours_committed_yearly_1 + area.hours_committed_yearly_2
            ).toFixed(1)
        );

        area.hours_completed_weekly = parseFloat(
            (
                (area.hours_completed_weekly_1 + area.hours_completed_weekly_2) /
                2
            ).toFixed(1)
        );
        area.hours_completed_yearly = parseFloat(
            (
                area.hours_completed_yearly_1 + area.hours_completed_yearly_2
            ).toFixed(1)
        );
        total += area.hours_committed_weekly * 36 + area.hours_committed_yearly;
        total_completed += area.hours_completed_weekly * 36 + area.hours_completed_yearly;
      });

      this.hours_weekly = parseFloat(
          this.data
              .reduce((acc, area) => acc + area.hours_committed_weekly, 0.0)
              .toFixed(1)
      );
      this.hours_yearly = parseFloat(
          this.data
              .reduce((acc, area) => acc + area.hours_committed_yearly, 0.0)
              .toFixed(1)
      );

      this.hours_eq = parseFloat(
          ((this.hours_weekly * 36 + this.hours_yearly) / 44).toFixed(1)
      );


      this.hours_completed_weekly = parseFloat(
          this.data
              .reduce((acc, area) => acc + area.hours_completed_weekly, 0.0)
              .toFixed(1)
      );
      this.hours_completed_yearly = parseFloat(
          this.data
              .reduce((acc, area) => acc + area.hours_completed_yearly, 0.0)
              .toFixed(1)
      );

      this.hours_completed_eq = parseFloat(
          ((this.hours_completed_weekly * 36 + this.hours_completed_yearly) / 44).toFixed(1)
      );

      this.data.forEach((area) => {
        if (total === 0) {
          area.percentage = 0;
        } else {
          area.percentage = parseFloat(
              (
                  ((area.hours_committed_weekly * 36 +
                          area.hours_committed_yearly) /
                      total) *
                  100
              ).toFixed(1)
          );
        }

        if (total_completed === 0) {
          area.percentage_completed = 0;
        } else {
          area.percentage_completed = parseFloat(
              (
                  ((area.hours_completed_weekly * 36 +
                          area.hours_completed_yearly) /
                      total_completed) *
                      100
              ).toFixed(1)
          )
        }

      });
    },
  },

  watch: {
    academic_areas() {
      this.getConsolidated();
      deep: true;
    },

    performances() {
      this.calculateConsolidated();
      deep: true;
    },
  },
};
</script>
